import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './Subscribe.css'; 

function SubscribeSuccessfully() {
    const navigate = useNavigate();
    const { cin } = useParams();

    const handlesuccess = () => {
        navigate(`/kohere/mycredits`);
    };

    return (
        <div className="subscribe-success-container">
            <h1 className="success-title">Payment Successful!</h1>
            <p className="success-message">Thank you for your payment. Your subscription is now active.</p>
            <button className="continue-button" onClick={handlesuccess}>Continue to Dashboard</button>
        </div>
    );
}

export default SubscribeSuccessfully;
